'use client';

/* ปุ่ม "อื่นๆ" บนแถบล่าง + แผงเมนูทั้งหมด (bottom sheet) ของตัวเอง — แยกจากเมนู ☰ ใน AuthWidget
   ทำงานทุกหน้ารวมหน้าบทความ (staticAuth) · แถบล่างอยู่เหนือแผง ปุ่มนี้กดซ้ำเพื่อปิด */
import { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import LineIcon from './LineIcon';
import { THEME_URL, clearToken } from '../lib/auth';

const ITEMS = [
  { href: '/wallet?tab=history', icon: 'history', label: 'ประวัติฝาก-ถอน' },
  { href: '/bank', icon: 'bank', label: 'บัญชีธนาคาร' },
  { href: '/cashback', icon: 'cashback', label: 'คืนยอดเสีย' },
  { href: '/affiliate', icon: 'link', label: 'ลิ้งรับทรัพย์' },
  { href: '/active-promotion', icon: 'pin', label: 'โปรที่เข้าร่วม' },
  { href: '/promotions?tab=code', icon: 'ticket', label: 'แลกโค้ด' },
  { href: '/change-pin', icon: 'lock', label: 'เปลี่ยน PIN' },
  { href: '/setting-dns', icon: 'tool', label: 'แก้บล็อกเว็บ' },
  { href: 'LINE', icon: 'chat', label: 'ติดต่อเรา' },
];

function useLine() {
  const [url, setUrl] = useState('/contact');
  useEffect(() => {
    let dead = false;
    fetch(THEME_URL).then((r) => r.json()).then((d) => {
      const line = (d.contact || []).find((c) => String(c.channel).toUpperCase() === 'LINE');
      if (!dead && line?.url) setUrl(line.url);
    }).catch(() => {});
    return () => { dead = true; };
  }, []);
  return url;
}

export default function QbarMore({ children }) {
  const [open, setOpen] = useState(false);
  const line = useLine();
  const sheet = useRef(null);
  const startY = useRef(null);
  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.activeElement;
    const y = window.scrollY;
    const body = document.body.style;
    const saved = { position: body.position, top: body.top, width: body.width };
    Object.assign(body, { position: 'fixed', top: `-${y}px`, width: '100%' });   // ล็อกหน้าหลัง (iOS ไม่สน overflow:hidden)
    const focusables = () => [...(sheet.current?.querySelectorAll('a,button') || [])];
    focusables()[0]?.focus();
    const onKey = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const list = focusables(); const first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
      Object.assign(body, saved); window.scrollTo(0, y);
      prev?.focus?.();
    };
  }, [open, close]);

  const logout = () => {
    clearToken();
    window.dispatchEvent(new Event('ufathai-auth'));
    setOpen(false);
    window.location.href = '/';
  };

  return <>
    <a href="#" className={`qbar-more${open ? ' is-active' : ''}`} aria-haspopup="dialog" aria-expanded={open}
      onClick={(e) => { e.preventDefault(); setOpen((v) => !v); }}>{children}</a>
    {open && createPortal(
      <div className="qm-bg" onClick={(e) => { if (e.target === e.currentTarget) close(); }}>
        <div className="qm-sheet" ref={sheet} role="dialog" aria-modal="true" aria-label="เมนูทั้งหมด"
          onTouchStart={(e) => { startY.current = e.touches[0].clientY; }}
          onTouchEnd={(e) => { if (startY.current != null && e.changedTouches[0].clientY - startY.current > 70) close(); startY.current = null; }}>
          <div className="qm-head"><span className="qm-grip" aria-hidden="true" /><b>เมนูทั้งหมด</b>
            <button type="button" className="qm-close" onClick={close} aria-label="ปิดเมนู"><LineIcon name="close" size={20} /></button></div>
          <div className="qm-grid">
            {ITEMS.map((it) => it.href === 'LINE'
              ? <a key={it.label} className="qm-item" href={line} target={line.startsWith('http') ? '_blank' : undefined} rel="noopener" onClick={close}><span><LineIcon name={it.icon} /></span>{it.label}</a>
              : <a key={it.label} className="qm-item" href={it.href} onClick={close}><span><LineIcon name={it.icon} /></span>{it.label}</a>)}
          </div>
          <button type="button" className="qm-out" onClick={logout}><LineIcon name="logout" size={19} />ออกจากระบบ</button>
        </div>
      </div>, document.body)}
  </>;
}
